<template>
    <span>
        <v-navigation-drawer v-model="drawer"
                             app
                             right>
            <v-list>
                <v-divider></v-divider>
                <template v-for="(item, index) in items">
                    <v-list-tile :href="item.href"
                                 :to="{name: item.href}"
                                 :key="index">
                        <v-list-tile-action>
                            <v-icon light
                                    v-html="item.icon"></v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                            <v-list-tile-title v-html="item.title"></v-list-tile-title>
                        </v-list-tile-content>
                    </v-list-tile>
                </template>
            </v-list>
        </v-navigation-drawer>
        <v-toolbar dense
                   fixed>
            <v-btn router
                   flat
                   to="/viewfreight"
                   class="teal--text darken-2">Kangaruu - Beta</v-btn>
            <v-spacer></v-spacer>

            <v-btn class="teal--text darken-2"
                   router
                   flat
                   v-on:click="logout">
                logout
            </v-btn>

            <v-btn v-on:click="drawer = !drawer"
                   icon>
                <v-icon class="teal--text darken-2">more_vert</v-icon>
            </v-btn>
        </v-toolbar>

    </span>
</template>

<script>
import firebase from 'firebase'
import db from './fireBaseInit'

export default {
  name: 'toolbar',
  data () {
    return {
      user: '',
      drawer: false,
      items: [{
        href: 'viewfreight',
        router: true,
        title: 'View Freight',
        icon: 'local_shipping'
      }]
    }
  },
  methods: {
    logout: function () {
      firebase.auth().signOut().then(() => {
        this.$router.replace('/')
      })
    }
  },
  firestore () {
    const userId = firebase.auth().currentUser.uid
    return {
      user: db.collection('users').doc(userId)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/BrokerToolBar.vue